import classNames from "classnames";
import GlobeIcon from "assets/icons/globe.svg?react";
import { forwardRef, useState } from "react";
import useTranslate from "hooks/useTranslate";
import { usePhoneCountries } from "queries/usePhoneCountries";
import { PhoneCountry } from "types/PhoneCountries";
import { usePhoneCountriesStore } from "stores/phoneCountries";
import { changeStringField } from "redux/user/slice";
import { useDispatch } from "react-redux";
import { InputPhoneCountriesSearch } from "./InputPhoneCountriesSearch";

export const InputPhoneCountries = forwardRef<HTMLDivElement>((_, ref) => {
  const t = useTranslate();
  const dispatch = useDispatch();

  const { data: countries } = usePhoneCountries();
  const isOpen = usePhoneCountriesStore((state) => state.isPhoneCountriesOpen);
  const setIsPhoneCountryClicked = usePhoneCountriesStore(
    (state) => state.setIsPhoneCountryClicked,
  );

  const [searchValue, setSearchValue] = useState("");

  const filtredCountries = countries?.filter((country) =>
    t(country.name)
      .toLowerCase()
      .startsWith(searchValue?.toLowerCase() ?? ""),
  );

  const handleChangeSearch = (value: string) => {
    setSearchValue(value);
  };

  const handleCountryClick = (value: PhoneCountry) => {
    dispatch(changeStringField({ field: "phoneCountry", value }));
    setIsPhoneCountryClicked(true);
  };

  const countriesClass = classNames("InputPhone__countries", {
    open: isOpen,
  });

  return (
    <div className={countriesClass} ref={ref}>
      <div className="InputPhone__countries_header">
        <div className="InputPhone__countries_title">
          {t("casino.countries.select")}
        </div>
        <InputPhoneCountriesSearch
          value={searchValue}
          onChange={handleChangeSearch}
        />
      </div>

      {filtredCountries?.map((country) => {
        return (
          <div
            key={country.isoCode}
            className="InputPhone__countries_item"
            onClick={() => handleCountryClick(country)}
          >
            <div className="InputPhone__countries_item_icon">
              {country?.flagUrl ? (
                <img src={country?.flagUrl} alt={t(country.name)} />
              ) : (
                <GlobeIcon />
              )}
            </div>
            {t(country.name)}
          </div>
        );
      })}
    </div>
  );
});
